import type { ComponentPropsWithoutRef } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { CustomButton } from "./CustomButton";
import { defaultStyle } from "./defaultStyle";

export interface PaginationItemProps
  extends Omit<ComponentPropsWithoutRef<"button">, "type"> {
  index: number;
  page: number;
  selected: boolean;
  type: "start-ellipsis" | "end-ellipsis" | "page" | "previous" | "next";
}

export const PaginationItem = ({
  page,
  type,
  selected,
  index,
  ...props
}: PaginationItemProps) => {
  if (type === "start-ellipsis" || type === "end-ellipsis") {
    return (
      <div key={`ellipsis-${index}`} className={defaultStyle}>
        {t("datatable.ellipsis")}
      </div>
    );
  }

  if (type === "page") {
    return (
      <CustomButton
        key={`page-${page}-${index}`}
        properties={props}
        isSelected={selected}
      >
        <Typography.LabelSm weight={selected ? "bold" : "medium"}>
          {page}
        </Typography.LabelSm>
      </CustomButton>
    );
  }

  const labelName =
    type === "previous"
      ? t("datatable.footer.previous")
      : t("datatable.footer.next");

  const iconType = type === "previous" ? "20-chevron-left" : "20-chevron-right";

  return (
    <Button variant="secondary" key={`${type}-${index}`} {...props}>
      <span className="sm:hidden">
        <Icon type={iconType} size={20} />
      </span>
      <span className="hidden sm:inline">{labelName}</span>
    </Button>
  );
};
